import handleSubMenuClick from '../function/HandleSubMenuClick';
import { useNavigation } from '../function/navigation';

function NavigationButtons({ allPages, clickTriggeredRef, isProduct }) {
  const { nav, dispatch } = useNavigation();

  const handleClickNext = () => {
    if (nav.mainPage === 'product') {
      dispatch({ type: 'productCurrentPage', payload: { menu: 'product' } });
    } else {
      const index = allPages.indexOf(nav.currentPage) + 1;
      selectPage(allPages[index]);
    }
  };

  const handleClickPrevious = () => {
    if (nav.mainPage === 'product') {
      dispatch({ type: 'productCurrentPage', payload: { menu: 'pdp' } });
    } else {
      const index = allPages.indexOf(nav.currentPage) - 1;
      selectPage(allPages[index]);
    }
  };

  const setCurrentPage = (page) =>
    dispatch({ type: 'currentPage', payload: page });

  const selectPage = (page) => {
    handleSubMenuClick(page, setCurrentPage, clickTriggeredRef);
  };

  const showPrev =
    nav.mainPage === 'product'
      ? nav.productCurrentPage.menu === 'product'
      : allPages?.length > 0 && nav.currentPage !== allPages?.[0];
  const showNext =
    nav.mainPage === 'product'
      ? nav.productCurrentPage.menu === 'pdp' && isProduct
      : allPages?.length > 0 &&
        nav.currentPage !== allPages?.[allPages.length - 1];

  return (
    <div className="navigation-buttons">
      <button
        className="button-md button-primary"
        disabled={!showPrev}
        onClick={handleClickPrevious}
      >
        <div className="arrow nav-up"></div>
      </button>
      <button
        className="button-md button-primary"
        onClick={handleClickNext}
        disabled={!showNext}
      >
        <div className="arrow nav-down"></div>
      </button>
    </div>
  );
}

export default NavigationButtons;
